import {observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class ProrrogacaoMOTRealizadaStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.indicadorService = new IndicadorService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findProrrogacaoMOTRealizada(filtro).then(response => {
            if(response.data) {
                this.dados = [
                    {nome: 'Prorrogadas', value: response.data.renovadas},
                    {nome: 'Não prorrogadas', value: response.data.naoRenovadas}
                ];
            } else {
                this.dados = [];
            }

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }
}
